import {InitPage} from "../index";
import * as Toastr from "toastr";
import axios from "axios";

declare var $;
declare var bulkCreateUrl;
declare var bulkModifyUrl;
declare var bulkDisposeUrl;
declare var releaseIndexUrl;
declare var baseUrl;

class Disposal {
    constructor() {

        if (typeof baseUrl === 'string') {
            const urlParams = new URLSearchParams(location.search);
            axios.get(`${baseUrl}/disposal_count_async.json?${urlParams}`).then((resp) => this.displayData(resp.data));
        }

    }

    displayData(resp: any) {
        $("#count_step_1").text(resp.step_1);
        $("#count_step_2").text(resp.step_2);
        $("#count_step_3").text(resp.step_3);
        $("#count_step_4").text(resp.step_4);
    }
    init() {
        $("#bulk-dispose").on("click", () => {
            const epcTagIds = $(".select-item:checked").map(function() {
              return $(this).val();
            }).get();

            if (epcTagIds.length === 0) {
                Toastr.error("No Item Number Selected");
                return;
            }

            $.ajax({
              dataType: "jsonp",
              url: bulkDisposeUrl,
              method: "POST",
              data: {
                epc_tag_ids: epcTagIds
              }
            });
        });

        $(".dispose-btn").on("click", function (event) {
            if ($(this).attr("disabled")) {
                event.stopPropagation();
                Toastr.error("No Item Number Selected");
            } else {
                $("#dispose-modal").modal("show");
            }
        });

        $(".select-item").on("click", this.enableDisableBtn);

        $("#quality_hold_reason").select2();
        $("#submitted_by_id").select2();
        $("#approved_by_id").select2();
        $("#disposal_reason_value").select2();
        $("#idr_id").select2();
        $("#disposed_by_id").select2();
        $("#per_page_value").select2();
        $("#query").select2();
        $("#sub_zone").select2();
        $("#qh_reason_value").select2();
        $("#qh_id").select2();
        $(".expectedCompleteTime").daterangepicker({
            "singleDatePicker": true,
            "timePicker": false,
            locale: {
                format: "M/DD/YYYY"
            }
        });
        $(".select-item-all").on("click", () => {
            if ($(".select-item-all:checked").length > 0) {
                $(".select-item").prop("checked", true);
            }
            else {
                $(".select-item").prop("checked", false);
            }
            this.enableDisableBtn();
        });
    }

    enableDisableBtn() {
        const daIds = $(".select-item:checked").map(function() {
              return $(this).val();
            }).get();
        $("#da_ids").val(daIds);

        if ($(".select-item:checked").length > 0) {
            $(".qh-btn").removeAttr("disabled");
            $(".qh-btn").removeClass("disabled");
            $("#bulk-dispose").removeAttr("disabled");
            $("#bulk-dispose").removeClass("disabled");

        }
        else {
            $(".qh-btn").attr("disabled", true);
            $(".qh-btn").addClass("disabled");
            $("#bulk-dispose").attr("disabled", true);
            $("#bulk-dispose").addClass("disabled");

        }
    }
}

export function LoadPage() {
    InitPage("disposals", () => {
        const disposals = new Disposal();
        disposals.init();
    });
}
